/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type GetOrganizationUsersQueryVariables = Types.Exact<{
  where: Types.Organization_Users_Bool_Exp;
  offset: Types.Scalars['Int']['input'];
  limit: Types.Scalars['Int']['input'];
  orderBy?: Types.InputMaybe<
    Array<Types.Organization_Users_Order_By> | Types.Organization_Users_Order_By
  >;
}>;

export type GetOrganizationUsersQuery = {
  __typename?: 'query_root';
  organization_users_aggregate: {
    __typename?: 'organization_users_aggregate';
    aggregate?: { __typename?: 'organization_users_aggregate_fields'; count: number } | null;
  };
  organization_users: Array<{
    __typename?: 'organization_users';
    user_id: string;
    organization_id: string;
    disabled: boolean;
    user: {
      __typename?: 'users';
      id: string;
      email?: string | null;
      displayName: string;
      password_disabled: boolean;
      principalType: Types.AuthPrincipalTypes_Enum;
    };
    role: {
      __typename?: 'roles';
      id: string;
      name: string;
      system_role?: Types.System_Roles_Enum | null;
    };
  }>;
};

export const GetOrganizationUsersDocument = `
    query GetOrganizationUsers($where: organization_users_bool_exp!, $offset: Int!, $limit: Int!, $orderBy: [organization_users_order_by!]) {
  organization_users_aggregate(where: $where) {
    aggregate {
      count
    }
  }
  organization_users(
    where: $where
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) {
    user_id
    organization_id
    user {
      id
      email
      displayName
      password_disabled
      principalType
    }
    disabled
    role {
      id
      name
      system_role
    }
  }
}
    ` as string & TypedDocumentNode<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetOrganizationUsers: build.query<
      GetOrganizationUsersQuery,
      GetOrganizationUsersQueryVariables
    >({
      query: (variables) => ({ document: GetOrganizationUsersDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetOrganizationUsersQuery, useLazyGetOrganizationUsersQuery } = injectedRtkApi;
